/**
 * Deck lists need identities and scheduling; display content comes from the content DB. Keep full
 * scheduler state and user-authored descriptions in the per-card detail reads.
 * Every content overlay remains joined so no drill kind disappears from a deck.
 */
export const DECK_STUDY_CARD_QUERY_CONFIG = {
  columns: {
    createdAt: true,
    id: true,
    manuallyMasteredAt: true,
    skippedAt: true,
    startedStudyingAt: true,
  },
  with: {
    fsrsCard: {
      columns: { due: true, lastReview: true, reps: true, scheduledDays: true, stability: true },
    },
    userGraphemeMeaningCard: { columns: { grapheme: true } },
    userGraphemePronunciationCard: { columns: { grapheme: true, pinyin: true } },
    // Quiz cards have no deck row (no glyph to tile); joined so stats can count them on request.
    userQuizCard: { columns: { key: true } },
    userWordSentenceCard: { columns: { kind: true, pinyin: true, word: true } },
  },
} as const;
